import { ReactNode } from 'react';

import Link from '@/components/core/Link';

interface IMobileMenuItemWrapperProps {
  isNotUrl: boolean;
  className: string;
  href: string;
  onClick: () => void;
  children: ReactNode;
}
function MobileMenuItemWrapper({
  isNotUrl,
  className,
  href,
  onClick,
  children,
}: IMobileMenuItemWrapperProps) {
  if (isNotUrl) {
    return <div className={className}>{children}</div>;
  }
  return (
    <Link className={className} href={href} onClick={onClick}>
      {children}
    </Link>
  );
}

export default MobileMenuItemWrapper;
